import { createFileRoute, notFound } from "@tanstack/react-router";
import ServicePage, { serviceSlugRedirects } from "@/pages/ServicePage";
import { legacyRedirect } from "@/lib/legacy-redirect";
import { isServiceSlug, serviceHead } from "@/lib/route-seo";
import NotFound from "@/pages/NotFound";

// Legacy slug redirects ported from src/App.tsx
const LEGACY_SLUGS: Record<string, string> = {
  "hvac-repair": "/hvac-services/residential-hvac",
  "building-automation": "/hvac-services/building-automation-systems",
  "preventive-maintenance": "/hvac-services/hvac-preventative-maintenance",
  "preventative-maintenance": "/hvac-services/hvac-preventative-maintenance",
};

export const Route = createFileRoute("/hvac-services/$slug")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_SLUGS[params.slug];
    if (target) legacyRedirect(target);
    if (!isServiceSlug(params.slug) && !serviceSlugRedirects[params.slug]) throw notFound();
  },
  component: () => <ServicePage basePath="/hvac-services" baseLabel="HVAC Services" />,
  notFoundComponent: () => <NotFound hubPath="/hvac-services" hubLabel="HVAC Services" />,
  head: ({ params }) => serviceHead("/hvac-services", "HVAC Services", params.slug),
});
